import { render, staticRenderFns } from "./MunicipioCarregamento.vue?vue&type=template&id=e0e2d910"
import script from "./MunicipioCarregamento.vue?vue&type=script&lang=js"
export * from "./MunicipioCarregamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports